import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  KPI_HEALTH_BADGES,
  PORTFOLIO_MILESTONE_BADGES,
  PORTFOLIO_MILESTONES_BADGES,
  STUDY_MILESTONE_BADGES
} from '@catalogues';
import { BadgeConfig, BadgeTypes, KpiHealthEnum } from '@models';

@Component({
  selector: 'status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent implements OnInit, OnChanges {
  @Input() type!: BadgeTypes;
  @Input() badgeKey!: string;
  @Input() showLabel = true;

  kpiHealthBadges = KPI_HEALTH_BADGES;
  portfolioMilestoneBadges = PORTFOLIO_MILESTONE_BADGES;
  studyMilestonesBadges = STUDY_MILESTONE_BADGES;
  portfolioMilestonesBadges = PORTFOLIO_MILESTONES_BADGES;
  badge: BadgeConfig | undefined = undefined;

  ngOnInit() {
    this.getBadgeConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['badgeKey'] || changes['type']) {
      this.getBadgeConfig();
    }
  }

  getBadgeConfig() {
    switch (this.type) {
      case 'kpiHealth':
        this.badge = this.kpiHealthBadges[this.badgeKey as KpiHealthEnum];
        break;
      case 'portfolioMilestone':
        this.badge =
          this.portfolioMilestoneBadges[
            this.badgeKey as keyof typeof this.portfolioMilestoneBadges
          ];
        break;
      case 'portfolioMilestonesStatus':
        this.badge =
          this.portfolioMilestonesBadges[
            this.badgeKey as keyof typeof this.portfolioMilestonesBadges
          ];
        break;
      case 'studyMilestoneStatus':
        this.badge =
          this.studyMilestonesBadges[this.badgeKey as keyof typeof this.studyMilestonesBadges];
        break;
    }
    return this.badge;
  }
}
